import React from 'react'
import { Link } from 'react-router-dom'
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll'

interface CTAFinalSectionProps {
  ctaText: string
  ctaHref: string
  external?: boolean
}

const CTAFinalSection: React.FC<CTAFinalSectionProps> = ({ ctaText, ctaHref, external = false }) => {
  const revealRef = useRevealOnScroll<HTMLDivElement>()

  return (
    <section
      id="cta-final"
      className="py-20 bg-terra-500 text-cream-50"
      aria-labelledby="cta-final-titulo"
    >
      <div ref={revealRef} className="container mx-auto px-4 text-center">
        <p aria-hidden="true" data-reveal-item className="font-hand text-2xl text-cream-100 -rotate-2 mb-4">
          vai dar tempo.
        </p>
        <h2
          id="cta-final-titulo"
          data-reveal-item
          className="text-3xl md:text-4xl font-display mb-6"
        >
          A próxima prova não precisa{' '}
          <span className="italic font-normal text-cream-100">tomar seu domingo</span>.
        </h2>
        <p data-reveal-item className="reveal-delay-1 text-xl text-cream-100 mb-8 max-w-3xl mx-auto">
          Crie a primeira em menos de 5 minutos. 7 dias grátis, sem cartão.
        </p>
        <div data-reveal-item className="reveal-delay-2">
          {external ? (
            <a
              href={ctaHref}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-cream-50 hover:bg-cream-100 text-terra-700 rounded-caderno-xs text-lg font-semibold shadow-caderno-lg hover:shadow-caderno-xl transition-all inline-block focus:outline-none focus:ring-4 focus:ring-cream-200"
            >
              {ctaText}
            </a>
          ) : (
            <Link
              to={ctaHref}
              className="px-8 py-4 bg-cream-50 hover:bg-cream-100 text-terra-700 rounded-caderno-xs text-lg font-semibold shadow-caderno-lg hover:shadow-caderno-xl transition-all inline-block focus:outline-none focus:ring-4 focus:ring-cream-200"
            >
              {ctaText}
            </Link>
          )}
          <p className="mt-6 text-cream-100 text-sm">
            Sem cartão de crédito · Cancele quando quiser
          </p>
        </div>
      </div>
    </section>
  )
}

export default CTAFinalSection
